import React, { Component } from 'react';
import './partnersBlock.scss';
// import Slider from "react-slick";

import PartnerItem from './partnerItem';

import "../../../../../node_modules/slick-carousel/slick/slick.css";
import "../../../../../node_modules/slick-carousel/slick/slick-theme.css";

class PartnersBlock extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isMobile: false,
            isPartnersPage: false,
            // showMoreShopsFlag: false
        };

        this.onShowMoreShops = this.onShowMoreShops.bind(this)
    }

    componentDidMount() {
        let windowWidth = window.innerWidth;
        if (windowWidth <= 767) {
            this.setState({
                isMobile: true
            });
        }

        let url = window.location.href;
        if (url && url.indexOf('partners') !== -1) {
            this.setState({
                isPartnersPage: true
            });
        }
    }

    onShowMoreShops() {
        // this.setState({
        //     showMoreShopsFlag: !this.state.showMoreShopsFlag
        // })
        this.props.onShowMore()
    }

    render() {
        // const settings = {
        //     className: "center",
        //     centerMode: true,
        //     infinite: false,
        //     centerPadding: "45px",
        //     slidesToShow: 1,
        //     speed: 100,
        //     swipeToSlide: true
        // };

        var partner = (<span></span>);
        if (this.props && this.props.partners && this.props.partners.length > 0) {
            partner = this.props.partners.map((data, index) => {
                // if (!this.state.showMoreShopsFlag) {
                //     while (index < 16) {
                return (
                    <div className="col-md-6 col-lg-3 d-flex pt-md-4" key={index}>
                        <PartnerItem key={index} data={data} />
                    </div>
                )
                // }
                // } else {
                //     return (
                //         <div className="col-md-6 col-lg-3 d-flex pt-md-4" key={index}>
                //             <PartnerItem key={index} data={data} />
                //         </div>
                //     )
                // }
            });
        };

        return (
            <div className="partners-block">
                <div className="row">{partner}</div>
                {
                    this.props.showMoreShopsFlag ?
                        <div className="row d-flex justify-content-center ctm-btn-container">
                            <div className="col-12 col-md-6 col-lg-3">
                                <button onClick={this.onShowMoreShops}
                                    className="ctm-btn">
                                    Показать ещё
                                </button>
                            </div>
                        </div> : null
                }

            </div>
        );
    }
}

export default PartnersBlock;
